import { CircularProgress, Box } from '@mui/material'

type CircularProgressBarProps = {
  currentValue: number
  maxValue: number
  thickness: number
  color?: string
  size: string
  rearColor?: string
}

export const CircularProgressBar = (props: CircularProgressBarProps) => {
  const { currentValue, color, maxValue, size, rearColor, thickness } = props

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        thickness={thickness}
        size={size ? size : '2rem'}
        sx={{
          color: rearColor ?? 'rgba(255, 255, 255, 0.16)',
        }}
      />
      <CircularProgress
        variant="determinate"
        value={(currentValue / maxValue) * 100}
        thickness={thickness}
        size={size ? size : '2rem'}
        sx={{
          color: color ?? 'rgba(170, 170, 170, 1)',
          position: 'absolute',
          left: 0,
        }}
      />
    </Box>
  )
}
